import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import iframeEvents from "./iframe.ts";
import SzThemeProvider from "./providers/theme/SzThemeProvider.tsx";
import SzCompactIcon from "./ui/icons/react icons/sz-icons/SzCompactIcon.tsx";
import { isEvyveska, setIsEvyveska } from "./utills/iframeVariants.ts";
import { type HandshakeResponse, postMessageToIframeParent } from "./utills/iframeMessaging.ts";
import { initialConfig } from "./initialConfig.ts";
import SzBackdrop from "./ui/components/UISharedConstructors/Loading/SzBackDrop.tsx";

window.addEventListener("load", () => {
  // Send a handshake message to the parent to validate origin
  if (window.parent) {
    postMessageToIframeParent({type: "handshake", greeting: "Hello from imm"});
  }
});

function GoToContentButton() {
  if(isEvyveska()) {
    return null;
  }

  return (
    <Button
      variant="contained"
      color="secondary"
      href="https://www.spravazeleznic.cz/movity-majetek"
      target="_blank"
    >
      Přejít na obsah
    </Button>
  )
}

// Create a container and in case that root cannot be found throw an error
const container = document.getElementById("iframe-root");

const isEmbedded = window !== window.parent;

if (container) {
  iframeEvents();
  const root = createRoot(container);
  if (isEmbedded) {
    window.addEventListener("message", (event) => {
      if (event.data.type === "handshakeResponse") {
        const handshakeResponse: HandshakeResponse = event.data as HandshakeResponse;
        // Parent responded to the handshake
        if (handshakeResponse.isValid && handshakeResponse.response === "m4g1c-h4nD5h4k3!") {

          setIsEvyveska(handshakeResponse.isEvyveska ?? false);
          initialConfig.parentHashFromHandshake = event.data.hash;

          root.render(
            <React.StrictMode>
              <App/>
            </React.StrictMode>,
          );
        } else {
          root.render(
            <SzThemeProvider>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="100%"
                width="100%"
                gap={3}
              >
                <SzCompactIcon sx={{fontSize: "50vh"}}/>
                <Typography variant="h1" component="h1" color="error">
                  Tento obsah je majetkem Správy železnic s.o.
                </Typography>
                <Typography variant="h2" component="h2" color="error">
                  je možné jej zobrazit pouze skrze stránky Správy železnic
                </Typography>
                <GoToContentButton/>
              </Box>
            </SzThemeProvider>,
          );
        }
      }
    });
    root.render(
      <SzThemeProvider>
        <Box height="30em">
          <SzBackdrop message={"Načítáme inzeráty"}/>
        </Box>
      </SzThemeProvider>,
    );
  } else {
    root.render(
      <SzThemeProvider>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
          gap={3}
        >
          <SzCompactIcon sx={{fontSize: "50vh"}}/>
          <Typography variant="h1" component="h1" color="error">
            Tento obsah je majetkem Správy železnic s.o.
          </Typography>
          <Typography variant="h2" component="h2" color="error">
            je možné jej zobrazit pouze skrze stránky Správy železnic
          </Typography>
          <GoToContentButton/>
        </Box>
      </SzThemeProvider>,
    );
  }
} else {
  console.error("Root container not found. Failed to mount the application.");
}
